import styled from 'styled-components';
import ThemeHelper from '@themes/theme-helper';

export const Root = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    justify-content: center;
    align-items: center;

    width: 40px;
    height: 100%;

    &:hover {
      path {
        fill: ${colours.upf?.[500]} !important;
      }
  }
`;
});

export const ToggleButton = styled.button(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: ${colours.grey[200]};
    border: none;
    width: 100%;
    height: 100%;
  `;
});

export const ModalContentRow = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    align-items: center;
    padding-left: 10px;
    height: 32px;
    border-bottom: 1px solid ${colours.grey[400]};
    color: ${colours.grey[800]};
    cursor: pointer;

    &:hover {
      font-weight: 900;
    }

    &::nth-last-child(1) {
      border: none;
    }
  `;
});

export const ModalContentHeader = styled(ModalContentRow)`
  font-weight: 700;
  cursor: default;

  &:hover {
    background-color: white;
  }
`;

export const AllCellsIcon = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 10px;
  padding-top: 5px;
  width: 20px;
  height: 20px;
`;

export const ColorBlock = styled.div(props => {
  const { bgColor } = props;

  return `
    box-sizing: border-box;
    padding-left:3px;
    margin-right: 10px;
    height: 20px;
    width: 20px;
    background-color: ${bgColor};

    [class^='svgIconComponent'] {
      svg {
        background-color: transparent;
      }
    }
  `;
});